import { PresenceZone, PresenceZoneRequest } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useCreatePresenceZone(
  camId: string,
  onSuccess?: (zone: PresenceZone) => void
) {
  const url = `/v2/orm/presence/cameras/${camId}/zones`;
  const request = new Request(url, { method: 'POST' });

  return useAuthenticatedMutation<PresenceZone, PresenceZoneRequest>(request, {
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    onSuccessInvalidationKeys: [
      ['presence-zones', camId],
      ['presence-latest', camId],
    ],
    onSuccess,
  });
}

export default useCreatePresenceZone;
